export default __webpack_public_path__ + "static/media/design_request_aside_background.c15ea489.png";